import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  errorMsg: "",
  // update KYC
  updateProfileLoading: false,
  updateProfileError: "",
  updateProfileSuccessMsg: "",
  removeProfileLoading: false,
  removeProfileError: "",
  removeProfileSuccessMsg: "",
};

const updateProfileSlice = createSlice({
  name: "updateProfile",
  initialState,
  reducers: {
    // update KYC reducers
    updateProfileStart: (state) => {
      state.updateProfileLoading = true;
      state.updateProfileError = "";
    },
    updateProfileSuccess: (state, { payload }) => {
      state.updateProfileLoading = false;
      state.updateProfileError = "";
      state.updateProfileSuccessMsg = payload;
    },
    updateProfileFail: (state, { payload }) => {
      state.updateProfileLoading = false;
      state.updateProfileError = payload;
    },
    removeProfileStart: (state) => {
      state.removeProfileLoading = true;
      state.removeProfileError = "";
    },
    removeProfileSuccess: (state, { payload }) => {
      state.removeProfileLoading = false;
      state.removeProfileError = "";
      state.removeProfileSuccessMsg = payload;
    },
    removeProfileFail: (state, { payload }) => {
      state.removeProfileLoading = false;
      state.removeProfileError = payload;
    },
  },
});

export const {
  updateProfileStart,
  updateProfileSuccess,
  updateProfileFail,
  removeProfileStart,
  removeProfileSuccess,
  removeProfileFail,
} = updateProfileSlice.actions;

export const updateProfileReducer = updateProfileSlice.reducer;
